import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import {Icon, ThemeContext} from '../';

// NOTE: previously `Radium(Button)` with inline `:hover`/`:focus` style objects.
// Radium throws "each element with interactive styles must have a unique key"
// when its resolver encounters multiple keyless interactive elements, which crashed
// the lobby/game into the error boundary ("Something went wrong"). The hover/focus
// states are already defined in CSS (Common/Button/index.less: `.button_primary:hover`
// / `:focus`), so Radium is not needed — drop it and the inline pseudo-styles.
const Button = (props) => {
  const {
    text,
    icon,
    iconSize,
    type,
    theme,
    size,
    handler,
    iconColor,
    className,
    tabIndex,
    textColor,
    bgColor,
    disabled,
  } = props;
  const classes = classNames(
    'button',
    {
      [className]: Boolean(className),
      [`button_${theme}`]: Boolean(theme),
      [`button_size_${size}`]: Boolean(size),
    }
  );
  const clickHandler = (e, fn) => {
    if (!fn) {
      return;
    }
    e.preventDefault();
    fn();
  };

  const getButtonStyles = (template) => {
    if (theme === 'secondary') {
      return {color: textColor || template.primaryColor};
    }

    if (theme === 'primary') {
      return {backgroundColor: bgColor || template.primaryColor};
    }

    return {color: textColor};
  };

  return (
    <ThemeContext.Consumer>
      {template => (
        <button
          style={getButtonStyles(template)}
          tabIndex={tabIndex}
          disabled={disabled}
          type={type}
          className={classes}
          onClick={e => clickHandler(e, handler)}
        >
          {icon && (<Icon
            glyph={icon}
            color={iconColor}
            size={iconSize}
          />)}
          {text}
        </button>
      )}
    </ThemeContext.Consumer>
  );
};

Button.propTypes = {
  text: PropTypes.string,
  theme: PropTypes.string,
  size: PropTypes.string,
  icon: PropTypes.string,
  iconSize: PropTypes.string,
  type: PropTypes.string,
  iconColor: PropTypes.string,
  className: PropTypes.string,
  handler: PropTypes.func,
  tabIndex: PropTypes.number,
  textColor: PropTypes.string,
  bgColor: PropTypes.string,
  hideOutline: PropTypes.bool,
  disabled: PropTypes.bool,
};

Button.defaultProps = {
  text: '',
  theme: 'primary',
  size: '',
  icon: '',
  iconSize: '',
  iconColor: '',
  className: '',
  type: 'button',
  handler: null,
  tabIndex: 0,
  textColor: '',
  bgColor: '',
  hideOutline: false,
  disabled: false,
};

export default Button;
